/**
 * ADMIN MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

import { Navigate } from "react-router-dom";
import { usePlatformAdmin } from "../../shared/hooks/usePlatformAdmin.js";

// Route guard for the admin module. "super_admin" maps to Brand Command staff
// in the platform_admins table (the app's real cross-tenant staff role) via
// usePlatformAdmin(). Non-staff are redirected to the dashboard SILENTLY — no
// message, no hint that an admin area exists. Server RLS is the hard boundary;
// this only keeps the UI invisible.
export function RequireSuperAdmin({ children }) {
  const { isAdmin, checked } = usePlatformAdmin();
  if (!checked) return null;            // resolving — render nothing
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
}
